import React, { useState } from 'react';
import './FAQ.css';
import GradualSpacingText from './GradualSpacingText/GradualSpacingText';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const faqData = [
  {
    question: 'What areas do you serve?',
    answer: 'We provide nationwide dry-van transportation covering the Southeast, Midwest, Northeast, Southwest, and West Coast, and can support port, DC, and multi-state supply chains.'
  },
  {
    question: 'How do I request a quote?',
    answer: 'Use our Contact / Request Quote form to provide origin, destination, and load details. We will respond promptly with capacity and pricing.'
  },
  {
    question: 'Do you offer dedicated lanes and contract freight?',
    answer: 'Yes - we provide dedicated and contract freight solutions with guaranteed capacity and scalable fleet support for long-term partnerships.'
  },
  {
    question: 'What about safety and insurance?',
    answer: 'We maintain active DOT & MC authority, $1,000,000 auto liability, $100,000 cargo insurance, FMCSA compliance, and ELD tracking on all equipment.'
  },
  {
    question: 'Can you support high-volume operations?',
    answer: 'Absolutely. We handle drop & hook and live-load operations for distribution centers, manufacturing plants, and port facilities.'
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="faq-headline">
          <GradualSpacingText text={"Got Questions? We Have Answers."} spacing="0.03em" stagger={20} />
        </h2>
      </motion.div>
      
      <div className="faq-list">
        {faqData.map((faq, index) => (
          <motion.div 
            key={index} 
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
            initial={{ opacity: 0, x: -10 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <button 
              className="faq-question" 
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
            >
              <span>{faq.question}</span>
              <motion.span 
                className="faq-icon"
                animate={{ rotate: openIndex === index ? 180 : 0 }}
                transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
              >
                <ChevronDown size={20} />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {openIndex === index && (
                <motion.div 
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
                  className="faq-answer-wrapper"
                >
                  <div className="faq-answer">
                    <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;

